import { trace } from 'rytm-helpers'
import Controller from './Controller'

class DatePickerController extends Controller {
  
  /**
  * on view Swap complete - just before SHOW
  * @param {Event} e
  **/
  onViewSwapComplete(e) {
    super.onViewSwapComplete(e)
  }
  addEventListeners() {
    super.addEventListeners()
    $("body").on("click", ".calendar-chocolate .months-nav a", $.proxy(this.onAjaxedNavClick, this))
  }
  removeEventListeners() {
    super.removeEventListeners()
    $("body").off("click", ".calendar-chocolate .months-nav a", $.proxy(this.onAjaxedNavClick, this))
  }

  /**
   * OWN
   */
  onAjaxedNavClick(e) {
    e.preventDefault();
    const href = e.currentTarget.getAttribute("href")
    const container = document.querySelector(this.getContainerSelector())
    container.classList.add("loading")
    const url = href + ".ajax"
    $.get(url, {}, (result) => {
      container.innerHTML = result
      container.classList.remove("loading")
    })
  }
  

}

export default DatePickerController;